import {useRef,useMemo} from "react";
import ManufacturingOrderPopup from '../ManufacturingOrder/ManufacturingOrderPopup.js';
import COMPONENT_MAP from '../Repository/Components.js';

const BatchDetailManufacturingOrders=({parentId,application,userData,parent,fromPopup=false}) =>{
    const list_name='batch_manufacturing_orders';
    const executeQuery=useRef(true);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                parent={parent}
                application={application}
                userData={userData}
                entityType={'ManufacturingOrder'}
                entityParams={['batch_id='+parentId,'_context='+['parent_name=Batch','parent_id='+parentId],'_lang='+application.globalData.lang]}
                list_name={list_name}
                file={'BatchDetailManufacturingOrders.js'}
                navigateOnNew={null}
                initialState={{}}
                checkboxSelection={false}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                popupComponent={ManufacturingOrderPopup}
                parentContext={{
                    parent_field_name:'batch_id',
                    parent_field_value:null,
                    parent_name:'Batch'
                }}
                executeQuery={executeQuery}
                fromPopup={fromPopup}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name],fromPopup]);

    return(renderListTab);
}
export default BatchDetailManufacturingOrders;
